<template>
    <div>
        <v-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            class="trigger invoices-table"
            ref="table"
            @row-click="onRowClick($event)"
        >
            <template slot="number" slot-scope="props">
                {{ props.row.number }}
            </template>
            <template slot="name" slot-scope="props">
                {{ props.row.name }}
            </template>
            <template slot="organisation" slot-scope="props">
                {{ props.row.organisation }}
            </template>
            <template slot="candidate_name" slot-scope="props">
                <span :style="props.row.is_anonymous ? 'color: gray' : ''">
                    {{ props.row.candidate_name }}
                </span>
                <small v-if="props.row.is_anonymous">({{ uLang('app.anonymous') }})</small>
            </template>
            <template slot="total_with_vat" slot-scope="props">
                {{ props.row.total_with_vat }}
            </template>
            <template slot="total_no_vat" slot-scope="props">
                {{ props.row.total_no_vat }}
            </template>
            <template slot="total_paid" slot-scope="props">
                {{ props.row.total_paid }}
            </template>
            <template slot="status" slot-scope="props">
                {{ uLang('app.' + props.row.status) }}
            </template>
            <template slot="invoice_date" slot-scope="{ row }">
                {{ row.invoice_date | date }}
            </template>
            <template slot="sent_at" slot-scope="{ row }">
                <template v-if="row.sent_at">
                    {{ row.sent_at | date }}
                </template>
                <template v-else>
                    {{ uLang('app.unsent') }}
                </template>
            </template>
            <template slot="expired_at" slot-scope="props">
                {{ props.row.expired_at | date }}
            </template>
            <template slot="booked" slot-scope="{ row }">
                {{ row.twinfield_booked ? uLang('app.yes') : uLang('app.no') }}
            </template>
            <template slot="filter__status">
                <multi-select
                    :options="statusses"
                    :loading="!statusses"
                    label="name"
                    :selectedLabel="uLang('app.select')"
                    :placeholder="uLang('app.select_an_option')"
                    @input="searchStatus"
                    :deselectLabel="uLang('app.press_enter_to_remove')"
                    :selectLabel="uLang('app.press_enter_to_select')"
                />
            </template>
        </v-server-table>
        <portal to="modals" v-if="showInvoice">
            <b-modal
                v-model="showInvoice"
                :hideFooter="true"
                :title="uLang('app.invoice')"
                size="lg"
            >
                <iframe
                    v-if="$can('view-sales-invoices')"
                    :src="route('export.invoice', {
                        invoice: this.clickedInvoice.id,
                        downloadType: 'stream',
                        cache: randomString()
                    })"
                    frameborder="0"
                    style="width: 100%; height: 60vh"
                ></iframe>
            </b-modal>
        </portal>
    </div>
</template>

<script>
    import { TableMixin } from '~/mixins'
    import { StatussesFilterMixin } from '~/mixins/table/filters'
    import Actions from './actions'
    import MultiSelect from 'vue-multiselect'

    export default {
        name: 'index',
        mixins: [ TableMixin, StatussesFilterMixin ],
        components: {
            MultiSelect
        },
        props: {
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        created() {
            this.$nextTick(() => {
                this.$refs.table.query.name = this.$route.query.search;
                this.$refs.table.refresh();
            });
        },
        data () {
            return {
                showInvoice: false,
                clickedInvoice: null,

                apiUrl: route('invoices.sales.table'),
                columns: [
                    'number',
                    'name',
                    'organisation',
                    'trajectory_name',
                    'candidate_name',
                    'total_with_vat',
                    'total_no_vat',
                    'status',
                    'invoice_date',
                    'sent_at',
                    'expired_at',
                    'booked',
                    'actions',
                ],
                filterable: [
                    'number',
                    'name',
                    'organisation',
                    'trajectory_name',
                    'candidate_name',
                    'invoice_date',
                    'sent_at',
                    'expired_at'
                ],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        number: this.uLang('app.invoice_number'),
                        name: this.uLang('app.contact'),
                        organisation: this.uLang('app.organisation'),
                        trajectory_name: this.uLang('app.trajectory_name'),
                        candidate_name: this.uLang('app.candidate_name'),
                        total_with_vat: this.uLang('app.total_with_vat'),
                        total_no_vat: this.uLang('app.total_no_vat'),
                        status: this.uLang('app.status'),
                        invoice_date: this.uLang('app.invoice_date'),
                        sent_at: this.uLang('app.sent_at'),
                        expired_at: this.uLang('app.expired_at'),
                        booked: this.uLang('app.booked'),
                        actions: this.uLang('app.actions'),
                    },
                    orderBy:{
                        column: 'number',
                        ascending:false
                    }
                },
                openToolTips: [],
            }
        },

        methods: {
            onRowClick(clickEvent) {
                // Check if they clicked a td (the row), so not a button or something.
                if(clickEvent.event.target.nodeName !== "TD" ) {
                    this.clickedInvoice = null
                    this.showInvoice = false
                    return;
                }

                this.clickedInvoice = clickEvent.row
                this.showInvoice = true
            },
            /**
             * Generate a random string
             * Used for cache busting when generating the PDF.
             *
             * @returns {string}
             */
            randomString() {
                return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            }
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        }
    }
</script>

<style lang="scss">
</style>
